<template>
  <div class="search-filter">
    <div class="row">
      <div class="col-md title"> {{title[$route.name]}}
        <em>{{totalItemsCount}} Results  ( Filtered to {{filteredItemsCount}} results )</em>
      </div>
      <div class="col-md show">
        <span>Show me:</span>
        <span v-bind:class="{ active: queryParams.show == 'all' }" @click="onChangeQueryParams({show: 'all'})">All Results</span>
        <span v-bind:class="{ active: queryParams.show == 'videos' }" @click="onChangeQueryParams({show: 'videos'})">Videos</span>
        <span v-bind:class="{ active: queryParams.show == 'figures' }" @click="onChangeQueryParams({show: 'figures'})">Figures</span>
        <span v-bind:class="{ active: queryParams.show == 'tags' }" @click="onChangeQueryParams({show: 'tags'})">Tags</span>
      </b-nav>
      </div>
    </div>
    <div class="filter-params row m-0 justify-content-between">
      <div class="col-md-auto">
        <span>Filter By:</span>
        <b-form-select v-bind:value="queryParams.paperType"
                       v-on:input="onChangeQueryParams({paperType: $event})"
                       :options="paperTypes"
        ></b-form-select>
        <b-form-select v-bind:value="queryParams.author"
                       v-on:input="onChangeQueryParams({author: $event})"
                       :options="authors"
        ></b-form-select>
        <b-form-select v-bind:value="queryParams.keyword"
                       v-on:input="onChangeQueryParams({keyword: $event})"
                       :options="keywords"
        ></b-form-select>
        <b-form-select v-bind:value="queryParams.vol"
                       v-on:input="onChangeQueryParams({vol: $event})"
                       :options="volumes"
        ></b-form-select>
        <b-form-select v-bind:value="queryParams.issue"
                       v-on:input="onChangeQueryParams({issue: $event})"
                       :options="issues"
        ></b-form-select>
        <b-form-input v-bind:value="queryParams.date"
                      v-on:input="onChangeQueryParams({date: $event})" class="custom-select" type="date" placeholder="Date"></b-form-input>
      </div>
      <div class="col-md-auto">
        <span>Sort By:</span>
        <b-form-select v-bind:value="queryParams.sortBy"
                       v-on:input="onChangeQueryParams({sortBy: $event})"
                       :options="sortBy"
        ></b-form-select>
      </div>
    </div>
    <div class="row m-0 justify-content-between filter-labels">
      <div class="col-md p-0">
        <filter-label v-for="(value, key) in queryParams"
                      v-if="value && key !== 'sortBy' && key !== 'show'"
                      :param-name="key"
                      :key="value"
                      v-on:remove="removeFilter($event)">
          {{value}}</filter-label>
      </div>
      <div class="col-md-auto">
        <b-button @click="clearFilters">
          Clear Filters
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import FilterLabel from '@/components/search-results/FilterLabelComponent'
  export default {
    name: 'search-filter',
    components: { FilterLabel },
    data () {
      return {
        totalItemsCount: 40,
        filteredItemsCount: 12,
        queryParams: {
          show: 'all',
          paperType: '',
          author: '',
          keyword: '',
          vol: '',
          issue: '',
          date: '',
          sortBy: 'Most Recently Added'
        },
        defaultQueryParams: {
          show: 'all',
          paperType: '',
          author: '',
          keyword: '',
          vol: '',
          issue: '',
          date: '',
          sortBy: 'Most Recently Added'
        },
        sortBy: ['Most Recently Added', 'Citations', 'Most Viewed', 'Altmetric'],
        // ToDO: replace with data from service
        paperTypes: [{text: 'Paper Type', value: ''}, 'Test', 'Test 1', 'Test 2'],
        authors: [{text: 'Author', value: ''}, 'Author 1', 'Author 2', 'Author 3'],
        keywords: [{text: 'Keyword', value: ''}, 'Keyword 1', 'Keyword 2', 'Keyword 3'],
        volumes: [{text: 'Vol', value: ''}, 1, 3, 4],
        issues: [{text: 'Issue', value: ''}, 120, 123, 121],
        title: {
          advanceOnlinePublications: 'Advance Online Publications',
          collectionDetail: 'Cover Papers',
          searchResults: 'Search Results',
          hundredPlus: '100+ Papers from the Editorial Board'
        }
      }
    },
    methods: {
      onChangeQueryParams: function (queryParam) {
        // queryParams - is an object that is collect selected filters - it can be used for request to server or results filtering
        this.queryParams = Object.assign({}, this.queryParams, queryParam)
      },
      removeFilter: function (paramName) {
        this.queryParams[paramName] = ''
        this.queryParams = Object.assign({}, this.queryParams)
      },
      clearFilters: function () {
        this.queryParams = Object.assign({}, this.defaultQueryParams)
      }
    },
    watch: {
      'queryParams': function () {
        this.$router.push({query: this.queryParams})
      },
      '$route.params.request': function (changed) {
        this.$route.meta['breadcrumbObject'] = {
          'Publications': '',
          'Search': {name: 'searchResults'},
          [`searched for: ${changed} `]: ''
        }
        this.clearFilters()
      }
    }
  }
</script>

<style scoped lang="scss">
  .search-filter {
    color: $primary-color;
    font-size: 12px;
    font-family: 'Merriweather', serif;
    border-top: 1px solid $grey-border;
    border-bottom: 1px solid $grey-border;
    padding: 30px 10px;
    margin: 10px 0;
    background-color: $light-grey-color;
    .title {
      font-size: 30px;
      line-height: 1;
      margin-bottom: 20px;
      white-space: nowrap;
      em {
        font-size: 16px;
        white-space: nowrap;
      }
    }
    .show {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      span {
        &:first-child {
          font-style: italic;
        }
        &:not(:first-child){
           text-decoration: underline;
           cursor: pointer;
           padding: 0px 8px;
           &:not(:last-child) {
              border-right: 1px solid $grey-border;
            }
         }
        &.active {
          text-decoration: none;
          font-weight: 600;
         }
      }
    }
    input[type=date]{
      width: initial;
    }
    .filter-labels{
      padding-top: 10px;
      margin-top: 10px;
      border-top: 1px solid $grey-border;
    }
    .filter-params {
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
    .custom-select {
      margin-bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// SearchFilterComponent.vue?372a2ac8